import { useContext } from 'react';
import Icon from '../../../dashboard/components/common/base/Icon';
import { Div } from '../../../dashboard/components/common/helpers/StyledUtils';
import { ConsoleEntriesContext } from '../context/ConsoleEntriesContext';
import EmptyState from './EmptyState';
import ConsoleEntriesTable from './EntriesTable';
import IngestNavigationNotice from './IngestNavigationNotice';

const EventSection = () => {
  const { entries } = useContext(ConsoleEntriesContext);

  // `entries` is undefined until the Source's requests have loaded. Rendering nothing here
  // used to be indistinguishable from a permanent stall: if the Source never resolved, the
  // fetch was never keyed, `entries` stayed undefined forever, and the Console showed its
  // top bar above a blank page with nothing in the browser console to explain it.
  if (!entries) {
    return (
      <Div
        h={100}
        p={{ all: 8 }}
        flex={{ direction: 'column', align: 'center', justify: 'center' }}>
        <Icon icon="loading" muted />
      </Div>
    );
  }

  const has_entries = entries.length > 0;

  return (
    <>
      <IngestNavigationNotice />
      {has_entries && <ConsoleEntriesTable />}
      {!has_entries && <EmptyState />}
    </>
  );
};

export default EventSection;
